import * as serviceWorkerRegistration from './registration';
export var registerServiceWorker = function () {
    return serviceWorkerRegistration.register({
        onUpdate: function (registration) {
            var waitingServiceWorker = registration.waiting;
            if (waitingServiceWorker) {
                waitingServiceWorker.addEventListener('statechange', function (event) {
                    if (event.target && event.target.state === 'activated') {
                        window.location.reload();
                    }
                });
                self.clients
                    .matchAll()
                    .then(function (all) {
                    return all.map(function (client) {
                        return client.postMessage({ type: 'UPDATE_AVAILABLE' });
                    });
                });
            }
        }
    });
};
//# sourceMappingURL=index.js.map